export default __webpack_public_path__ + "static/media/mechanical-loading-icon.20a42aae.svg";